import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as actions from '../actions/widget-columns.actions';
import { WidgetInstanceColumns } from '@feature/widget-columns/widget-columns-types';
import { IColumnDefinition } from '@common/models/column-definition';

export const widgetColumnsFeatureKey = 'widgetColumns';

export interface State extends EntityState<WidgetInstanceColumns> {
  allColumns: IColumnDefinition[],
}

export const adapter: EntityAdapter<WidgetInstanceColumns> = createEntityAdapter<WidgetInstanceColumns>();

export const initialState: State = adapter.getInitialState({
  allColumns: undefined
});

const widgetInstanceColumnsReducer = createReducer(
  initialState,
  on(
    actions.apiLoadAvailableColumns,
    (state, { widget }) => {
      return adapter.addOne({ id: widget.id, loading: true, columns: undefined }, state);
    }),

  on(
    actions.apiChangeSelectedColumns,
    actions.apiResetColumns,
    (state, { widget }) => {
      return adapter.upsertOne({ id: widget.id, loading: true, columns: undefined }, state);
    }),

  on(
    actions.apiChangeSelectedComplete,
    actions.apiResetColumnsComplete,
    actions.apiLoadColumnsComplete,
    (state, { widget, columns }) => {
      return adapter.upsertOne({ id: widget.id, loading: false, columns: columns }, state);
    }),

);




export function reducer(state: State | undefined, action: Action) {
  return widgetInstanceColumnsReducer(state, action);
}

